import { useNavigate } from 'react-router-dom';

const CartEmpty = () => {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <h2 className="text-2xl font-bold mb-4">Your cart is empty</h2>
      <button 
        onClick={() => navigate('/shop')} 
        className="btn btn-primary"
      >
        Continue Shopping
      </button>
    </div>
  );
};

export default CartEmpty;